import { ApiContact, apiContactToContact, Contact } from "../../apiResponse/contact";
import { OnsipAPIBoolean, onsipApiBooleanToBoolean } from "../../apiResponse/xml-json";

export interface OAuth2SignupAccount {
  accountId: string;
  account: {
    accountId: string;
    created: string;
    contact: Contact;
    receivable: string;
    promocode: string;
    productcode: string;
    meteredUserPricing: boolean;
    resellerBilling: boolean;
    invoicedPrepaid: boolean;
    noPrepaidCredit: true;
    noTermination: boolean;
    receivableIncentiveMonth: boolean;
    unlimitedUserPricing: boolean;
    unlimitedUltimateUserPricing: boolean;
    unlimitedRebornUserPricing: boolean;
    perUserPricing: boolean;
    balanceSeconds: number;
    escrowSecondsUpdate: number;
    escrowSecondsCredit: number;
    balance: number;
    creditLimit: number;
    recharge: boolean;
    rechargeLevel: number;
    rechargeThreshold: number;
    modified: string;
  };
  contact: Contact;
  userOAuth2AccessToken: {
    service: string;
    serviceUserId: string;
    userId: string;
    scope: string;
    token: string;
    userOAuth2AccessTokenId: string;
    organizationId: string;
  };
}

export declare interface OAuth2SignupAccountApi {
  Account: {
    AccountId: string;
    Created: string;
    Contact: ApiContact;
    Receivable: string;
    Promocode: string;
    Productcode: string;
    MeteredUserPricing: OnsipAPIBoolean;
    ResellerBilling: OnsipAPIBoolean;
    InvoicedPrepaid: OnsipAPIBoolean;
    NoPrepaidCredit: true;
    NoTermination: OnsipAPIBoolean;
    ReceivableIncentiveMonth: OnsipAPIBoolean;
    UnlimitedUserPricing: OnsipAPIBoolean;
    UnlimitedUltimateUserPricing: OnsipAPIBoolean;
    UnlimitedRebornUserPricing: OnsipAPIBoolean;
    PerUserPricing: OnsipAPIBoolean;
    BalanceSeconds: number;
    EscrowSecondsUpdate: number;
    EscrowSecondsCredit: number;
    Balance: number;
    CreditLimit: number;
    Recharge: OnsipAPIBoolean;
    RechargeLevel: number;
    RechargeThreshold: number;
    Modified: string;
  };
  UserOAuth2AccessToken: {
    Service: string;
    ServiceUserId: string;
    UserId: string;
    Scope: string;
    Token: string;
    UserOAuth2AccessTokenId: string;
    OrganizationId: string;
  };
}

export interface OAuth2SignupAccountParams {
  OAuthService: string | undefined;
  OAuthServiceUserId: string | undefined;
  OAuthToken: string | undefined;
  ContactName: string;
  ContactOrganization: string | undefined;
  DomainSubdomain: string;
  UserAddressUsername: string;
  ContactPhone: string | undefined;
  AccountPlan: string | undefined;
  ContactEmail: string | undefined;
}

export function oAuth2SignupAccountApiConverter(data: OAuth2SignupAccountApi): OAuth2SignupAccount {
  return {
    accountId: data.Account.AccountId,
    account: {
      accountId: data.Account.AccountId,
      created: data.Account.Created,
      contact: apiContactToContact(data.Account.Contact),
      receivable: data.Account.Receivable,
      promocode: data.Account.Promocode,
      productcode: data.Account.Productcode,
      meteredUserPricing: onsipApiBooleanToBoolean(data.Account.MeteredUserPricing),
      resellerBilling: onsipApiBooleanToBoolean(data.Account.ResellerBilling),
      invoicedPrepaid: onsipApiBooleanToBoolean(data.Account.InvoicedPrepaid),
      noPrepaidCredit: data.Account.NoPrepaidCredit,
      noTermination: onsipApiBooleanToBoolean(data.Account.NoTermination),
      receivableIncentiveMonth: onsipApiBooleanToBoolean(data.Account.ReceivableIncentiveMonth),
      unlimitedUserPricing: onsipApiBooleanToBoolean(data.Account.UnlimitedUserPricing),
      unlimitedUltimateUserPricing: onsipApiBooleanToBoolean(
        data.Account.UnlimitedUltimateUserPricing
      ),
      unlimitedRebornUserPricing: onsipApiBooleanToBoolean(data.Account.UnlimitedRebornUserPricing),
      perUserPricing: onsipApiBooleanToBoolean(data.Account.PerUserPricing),
      balanceSeconds: data.Account.BalanceSeconds,
      escrowSecondsUpdate: data.Account.EscrowSecondsUpdate,
      escrowSecondsCredit: data.Account.EscrowSecondsCredit,
      balance: data.Account.Balance,
      creditLimit: data.Account.CreditLimit,
      recharge: onsipApiBooleanToBoolean(data.Account.Recharge),
      rechargeLevel: data.Account.RechargeLevel,
      rechargeThreshold: data.Account.RechargeThreshold,
      modified: data.Account.Modified
    },
    contact: apiContactToContact(data.Account.Contact),
    userOAuth2AccessToken: {
      service: data.UserOAuth2AccessToken.Service,
      serviceUserId: data.UserOAuth2AccessToken.ServiceUserId,
      userId: data.UserOAuth2AccessToken.UserId,
      scope: data.UserOAuth2AccessToken.Scope,
      token: data.UserOAuth2AccessToken.Token,
      userOAuth2AccessTokenId: data.UserOAuth2AccessToken.UserOAuth2AccessTokenId,
      organizationId: data.UserOAuth2AccessToken.OrganizationId
    }
  };
}
